import React, {Component} from 'react';
import GameTile from './gametile';
import Levels from '../../src/data';

class GameColumn extends Component {
	constructor(props) {
	  super(props);
	  this.state = {
			completed: false,
			randomHanja: []
	  };
	}
	completeColumn = (char) => {
		this.setState({completed: true});
		console.log('key', this.props.keySyllable);
		this.props.checkWordComplete(char, this.props.keySyllable);
	}
	getRandomHanja(syllableToFilter){
	    //put all korean syllables into array
	    const ksyllables = Levels.map((level) => {
	      return {korean : level.korean, english : level.english};
	    });
	    //filter out passed arguments
	    const filtered = ksyllables.filter(function(val){

	      return syllableToFilter.indexOf(val.korean) === -1;
	    });

	    //generate array of random sylabbles TODO: just return just one
	    const randomHanjas = new Array(1).fill(undefined).map((val) => {
	      return filtered[Math.floor(Math.random() * filtered.length)];
			});
	    return randomHanjas;
	}
	componentWillMount(){
		if(this.props.syllable!==undefined){
		    const randomPosition = new Array(1).fill(undefined).map((val) => {
		        return 0.5 - Math.random();
		    });
		    const randomHanja = this.getRandomHanja(this.props.syllable);
		    this.setState({randomPosition: randomPosition, randomHanja: randomHanja})
		}
	}
  	render(){
		let tiles = null;
		console.log('red', this.props.keySyllable)
  		if(this.props.keySyllable){
  			tiles = [
	  				<GameTile
	  					completed={true}
	  					correct={true}
	  					clickTile={ this.props.clickTile }
	  					character={ this.props.syllable }
							minipad={ this.props.minipad }
	  					key={this.props.currentWord + " " + this.props.id}
	  					first={this.props.first}
	  					last={this.props.last} />]
	  	}else if(this.props.syllable !== undefined){
	  		//const showIncorrect = !this.state.complete;
  			//generate shuffled array of hanja and correct hanja with randomized position
	  		const options = [
	            <GameTile
					key={this.props.currentWord + " " + this.props.id + " 1"}
					completed={this.state.completed}
					correct={ false }
					showMistake={this.props.showMistake}
					character={ this.state.randomHanja.length ? this.state.randomHanja[0].korean : '' }
					meaning={ this.state.randomHanja.length ? this.state.randomHanja[0].english : '' }
					id={ this.props.id }
					keyid={ this.props.currentWord + " " + this.props.id + " 1" }
					completeColumn={this.completeColumn}
					minipad={ this.props.minipad }
					first={this.props.first}
  					last={this.props.last} />,
				<GameTile
					key={this.props.currentWord + " " + this.props.id + " 2"}
					correct={ true }
					completed={this.state.completed}
					completeColumn={this.completeColumn}
					character={ this.props.syllable }
					minipad={ this.props.minipad }
					id={ this.props.id }
					keyid={ this.props.currentWord + " " + this.props.id + " 2" }
					first={this.props.first}
  					last={this.props.last} />
					]
			const syllablePositions = this.state.randomPosition
	  		const shuffledOptions = options.sort(function(a, b){return syllablePositions});
	  		tiles = shuffledOptions;
	  	}
	  	return(
	  		<div className="game-tile-column">
	            {tiles}
			</div>
  		)

  	}
}
export default GameColumn;



// WEBPACK FOOTER //
// ./src/components/gamecolumn.js